import { computed, type ComputedRef } from 'vue'
import type { RattachementDTO } from '@/features/api/extranet/dto/Profil'
import { useContactCardMapping } from '@/features/interface/profil-utilisateur/sections/contacts/useContactCardMapping'
import { useOnboardingStore } from '../onboarding/useOnboardingStore'
import { useContactStore } from '@/features/interface/profil-utilisateur/sections/contacts/useContactsStore'
import { useRattachementsStore } from '@/features/interface/profil-utilisateur/sections/rattachements/useRattachementsStore.ts'
import { storeToRefs } from 'pinia'
import type { CardsLayoutType } from './tableauDeBord/cardsLayout/CardsLayout.types'
import { useAppStateStore } from '@/features/application'
import { TypesContextesAutorisesEnum } from '@/features/auth/context-app'
import { useRouter } from 'vue-router'
export interface HomeSection {
  cards: ComputedRef<CardProps[]>
  onClick: () => void
}

export function useHomeCardMapping() {
  const appState = useAppStateStore()
  const router = useRouter()
  const contactStore = useContactStore()
  const { chargerContacts } = contactStore
  const { homeContact } = storeToRefs(contactStore)

  const onboardingStore = useOnboardingStore()
  const { cardsListAgendas } = storeToRefs(onboardingStore)

  if (appState.contextCourant !== TypesContextesAutorisesEnum.Aucun) {
    chargerContacts()
  }

  const rattachementStore = useRattachementsStore()
  const { rattachements } = storeToRefs(rattachementStore)
  const { mapContactToCard } = useContactCardMapping()

  function mapRattachementToCard(rattachement: RattachementDTO): CardProps {
    const sirenText = rattachement.entite.siren ? rattachement.entite.siren.toString() : ''
    const nicText = rattachement.entite.nic ? rattachement.entite.nic.toString() : ''
    const titleText = [sirenText, nicText].filter(Boolean).join(' ')

    return {
      avatar: {
        type: 'icon',
        iconName: rattachement.typeEntreprise === 'Adherent' ? 'entreprise' : 'bank',
      },
      title: rattachement.entite.denomination,
      subtitles: titleText ? [{ text: titleText }] : [],
    }
  }

  const contactsCards = computed(() => homeContact.value?.map(mapContactToCard) ?? [])
  const rattachementsCards = computed(() => rattachements.value?.map(mapRattachementToCard) ?? [])
  const cardsListTaches = computed(() => [])

  function redirectExterne(url: string) {
    const a = document.createElement('a')
    try {
      a.href = url
      a.target = '_blank'
      document.body.appendChild(a)
    } finally {
      a.click()
      a.remove()
    }
  }

  function createHomeSection(cards: ComputedRef<CardProps[]>, onClick: () => void): HomeSection {
    return {
      cards,
      onClick,
    }
  }

  const homeCardsSubSections: Partial<Record<CardsLayoutType, HomeSection>> = {
    Contacts: createHomeSection(contactsCards, () => router.push({ name: 'Contacts' })),
    Rattachements: createHomeSection(rattachementsCards, () => router.push({ name: 'Rattachements' })),
    Actualités: createHomeSection(cardsListAgendas, () => redirectExterne('https://www.akto.fr/agenda/')),
  }

  return {
    homeCardsSubSections,
    cardsListTaches,
  }
}
